export const theme = {
  colors: {
    white: '#FFFFFF',
    blue10: '#000924',
    blue20: '#001657',
    blue30: '#00238a',
    blue40: '#0030bd',
    blue50: '#003DF0',
    gray20: '#333333',
    gray40: '#666666',
    gray70: '#b2b2b2',
    gray80: '#CCCCCC',
    gray90: '#E5E5E5',
    gray100: '#f5f5f5',
    turquoise70: '#91CDE8',
    turquoise80: '#bbe0f1',
    turquoise90: '#e6f3fa',
    peach70: '#F2BA91',
    peach80: '#FFD6AF',
    red50: '#c43b3b',
    coral70: '#FF8273',
    bio30: '#2F604B',
    bio40: '#408265',
    bio80: '#B4DAC9',

    primary: 'var(--color-brand)',
    primaryHover: 'var(--color-brand-hover)',
    title: 'var(--color-title)',
    text: 'var(--color-text)',
    border: 'var(--color-gray-2)',
    separator: 'var(--color-blue-1-3)',
    success: '#277241',
    danger: '#C43B3B',
    black: 'var(--color-black)',
    lightBlue: 'var(--color-blue-1-2)',
    link: 'var(--color-link)',
    linkHover: 'var(--color-link-hover)',
    background: {
      container: 'var(--background-container)',
      header: 'var(--background-header)',
      backdrop: 'var(--background-overlay)',
      infoBox: 'var(--color-blue-1)',
      ebGold: 'var(--color-eb-gold)',
      ebBonusGold: 'var(--color-eb-bonus-gold)',
      ebMember: 'var(--color-eb-member)',
      ebSilver: 'var(--color-eb-silver)',
      ebDiamond: 'var(--color-eb-diamond)',
      ebPandion: 'var(--color-eb-pandion)',
      noMember: '#FFFFFF',
    },

    gray: [
      'var(--color-gray-1)',
      'var(--color-gray-2)',
      'var(--color-gray-3)',
      'var(--color-gray-4)',
      'var(--color-gray-5)',
    ],
    blue: [
      'var(--color-blue-1)',
      'var(--color-blue-2)',
      'var(--color-blue-3)',
      'var(--color-blue-4)',
      'var(--color-blue-5)',
    ],
  },
  fontWeight: {
    normal: 'var(--font-weight-normal)',
    bold: 'var(--font-weight-bold)',
    black: 'var(--font-weight-black)',
  },
  typography: {
    h1: 'var(--font-h1)',
    h2: 'var(--font-h2)',
    h3: 'var(--font-h3)',
    h4: 'var(--font-h4)',

    p: 'var(--font-p)',
    pRebook: 'var(--font-p1)',
    pSmall: 'var(--font-p1-sm)',
    pMini: 'var(--font-p1-xs)',
  },
  fontSize: {
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    md: '1rem', // 16px
    lg: '1.125rem', // 18px
    xl: '1.25rem', // 20px
    xxl: '1.5rem', // 24px
  },

  breakpoints: {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    laptop: '992px',
    desktop: '1152px',
    values: {
      mobileS: 320,
      mobileM: 375,
      mobileL: 425,
      tablet: 768,
      laptop: 992,
      desktop: 1152,
    },
  },

  spacing: {
    xss: '0.125rem', // 2px
    xs: '0.25rem', // 4px
    sm: '0.5rem', // 8px
    ms: '0.75rem', // 12px
    md: '1rem', // 16px
    lg: '1.5rem', // 24px
    xl: '2rem', // 32px
    xxl: '2.5rem', //40px
    xxxl: '3rem', //48px
    values: {
      xs: 0.25,
      sm: 0.5,
      ms: 0.75,
      md: 1,
      lg: 1.5,
      xl: 2,
      xxl: 2.5,
      xxxl: 3,
    },
  },

  borders: {
    border: '1px solid var(--color-border)',
    radius: {
      sm: '4px',
      md: '8px',
      lg: '12px',
      xl: '16px',
    },
    widths: {
      sm: '1px',
      md: '2px',
    },
  },

  shadows: {
    md: 'var(--shadow-normal)',
  },

  transitions: {
    fast: '0.15s var(--ease-in-out-brand)',
    normal: '0.3s var(--ease-in-out-brand)',
    slow: '0.5s var(--ease-in-out-brand)',
  },
};
